function remove_unwanted_filter_options_by_urls(urls_array) {
  for (let i = 0; i < urls_array.length; i++) {
    if (document.URL.includes(urls_array[i])) {
      var filter_price_element = document.getElementsByClassName("ring_filter_price")[0];
      if (filter_price_element) {
        var elements = Array.from(filter_price_element.parentElement.children);
        for (let i = 0; i < elements.length; i++) {
          if (!elements[i].classList.contains("ring_filter_price")) {
            elements[i].remove();
          } else {
            elements[i].classList.remove("col-lg-4");
            elements[i].classList.add("col-lg-3");
          }
        }
      } else {
        console.warn("didnt find ring_filter_price class");
      }
      break;
    }
  }
}

function remove_unwanted_filter_metal_option_by_urls(urls_array) {
  for (let i = 0; i < urls_array.length; i++) {
    if (document.URL.includes(urls_array[i])) {
      var filter_price_element = document.getElementsByClassName("ring_filter_price")[0];
      if (filter_price_element) {
        var elements = Array.from(filter_price_element.parentElement.children);
        for (let i = 0; i < elements.length; i++) {
          if (elements[i].classList.contains("ring_filter_price")) {
            elements[i].classList.remove("col-lg-4");
            elements[i].classList.add("col-lg-3");
          } else if(elements[i].classList.contains("ring_filter_designers")){
            
          } else {
            elements[i].remove();
          }
        }
      } else {
        console.warn("didnt find ring_filter_price class");
      }
      break;
    }
  }
}

function add_style_to_empty_budget() {
  var filter_price_element = document.getElementsByClassName("ring_filter_price")[0];
  if (filter_price_element) {
    var elements = Array.from(filter_price_element.parentElement.children);
    if (elements.length == 1) {
      console.warn("1111111111111111");
      var el = document.createElement("style");
      el.appendChild(document.createTextNode(".ring_filter_price {width: 60%; margin: auto;} .ring_filter_price .slideView{width: auto;}"));
      filter_price_element.appendChild(el);
    } else if(elements.length == 2 && elements[0].tagName.toLocaleLowerCase() == "style") {
      console.warn("2222222222222222");
      var el = document.createElement("style");
      el.appendChild(document.createTextNode(".ring_filter_price {width: 60%; margin: auto;} .ring_filter_price .slideView{width: auto;}"));
      filter_price_element.appendChild(el);
    }
  } else {
    console.warn("didnt find ring_filter_price class");
  }
}

window.addEventListener('load', function() {
  try {
    remove_unwanted_filter_options_by_urls([
      "collections/all?style=Lab+Grown+Diamond+Jewelry",
      "collections/all?style=Mens+Jewelry",
      "collections/all?style=Gold+Jewelry&itemsPerPage=20",
      "collections/bracelet?diamond=Pearl",
      "collections/all?style=Colored+Gemstone&itemsPerPage=20",
      "collections/all?style=Necklace",
      "collections/all?itemsPerPage=20"
    ]);
      
    remove_unwanted_filter_metal_option_by_urls([
     "collections/all?occasion=Religious+Jewelry",
     "collections/all?occasion=Birthstones",
     "collections/all?occasion=Graduation",
     "collections/all?occasion=Anniversary",
     "collections/all?occasion=Push+Present"
    ]);
  } catch (error) {
    console.error("here "+error);
  }

  add_style_to_empty_budget();
})